import { Component, Input, OnInit } from '@angular/core';
import { InAppBrowser } from '@capgo/inappbrowser';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-not-available',
  templateUrl: './not-available.component.html',
  styleUrls: ['./not-available.component.scss'],
})
export class NotAvailableComponent {
  @Input() downloadLink: string = '';

  constructor(private modalCtrl: ModalController,
              private translate: TranslateService
  ) { }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  downloadApp() {
    if (!this.downloadLink) {
      console.error('Download link not provided');
      return;
    }
    
    if (Capacitor.isNativePlatform()) {
      InAppBrowser.open({ url: this.downloadLink });
    } else {
      window.open(this.downloadLink, '_blank');
    }
  }

}
